export default __webpack_public_path__ + "static/media/555.24ee9c54.png";